export default __webpack_public_path__ + "static/media/singapore.102a0a12.png";